import { FC, useState } from 'react';
import styled from '@emotion/styled';
import { useQuery, useReactiveVar } from '@apollo/client';
import { AppBar as _AppBar, Tab, Tabs, Typography, withStyles } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../theme/colors';
import { lastAccessedOrganizationVar } from '../../cache';
import { useParams } from 'react-router';
import { GetProjectDocument, GetProjectQuery, GetProjectQueryVariables, Project } from '../../generated/graphql';
import globalState from '../../operations/commands';
import { Message } from '../component/compound/ExperimentDetails/Message';
import { useSearchParams } from 'react-router-dom';

type Params = {
  experiment_id: string;
};

const ExperimentDetailsPage: FC<{
  className?: string;
}> = () => {
  const { experiment_id } = useParams<Params>();
  const lastOrg = useReactiveVar(lastAccessedOrganizationVar);
  const organization_id = lastOrg!.id;
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabId, setTabId] = useState(searchParams.get('tab') ? searchParams.get('tab') : 'overview');
  const [project, setProject] = useState<Project>();

  useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, {
    skip: !organization_id || !experiment_id,
    variables: { id: experiment_id! },
    context: { clientName: 'planbcd' },
    onCompleted: (data: GetProjectQuery): void => {
      setProject(data.project as Project);
    },
    onError: (error) => {
      console.error(error);
      globalState.setErrors({
        message: 'error',
        name: 'NonFatalError',
        context: { clientName: 'search_console' },
      });
    },
  });

  return (
    <div className="" style={{ maxWidth: '1088px', margin: 'auto auto' }}>
      <Container>
        {/* ページタイトル */}
        <Header>
          <Title>{project?.title}</Title>
          {/* <PrimaryButton onClick={() => false}>デザイン案を作成する</PrimaryButton> */}
        </Header>

        {/* タブ */}
        <AppBar color="transparent" position="static">
          <TabsPayment
            value={tabId}
            onChange={(_: any, v: string) => {
              setSearchParams({ tab: v });
              setTabId(v);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
          >
            <Tab value="overview" label={'エクスペリエンスの概要'} disableRipple />
            <Tab value="variations" label={'デザイン案'} disableRipple />
            <Tab value="message" label={'掲示板'} disableRipple />
            <Tab value="report" label={'レポート'} disableRipple />
            <Tab value="deliverySettings" label={'配信設定'} disableRipple />
          </TabsPayment>
        </AppBar>

        {/* タブの中身をtabIdに応じて表示 */}
        {/* {tabId === 'overview' ? <Overview /> : null} */}
        {/* {tabId === 'variations' ? <Variations /> : null} */}
        {tabId === 'message' ? <Message /> : null}
        {/* {tabId === 'report' ? <Report /> : null}
        {tabId === 'deliverySettings' ? <DeliverySettings /> : null} */}
      </Container>
    </div>
  );
};

const AppBar = styled(_AppBar)(`
  margin: 15px 10px 45px 10px;
  box-shadow: none;
`);

const Container = styled('div')(`
  padding: 36px 0;
  position: relative;
`);

const Header = styled('div')(`
  display: flex;
  justify-content: space-between;
  margin-bottom: 36px;
  width: 100%;
`);

const TabsPayment = withStyles({
  root: {
    '& .MuiTabs-scroller': {
      '& button.Mui-selected,button.MuiTab-root': {
        minWidth: 'unset',
        paddingLeft: '0',
        paddingRight: '0',
        marginRight: '30px',
        fontWeight: '700',
        fontFamily: 'Hiragino Sans',
      },
      '& .MuiTab-textColorPrimary.Mui-selected': {
        color: '#4C566C',
        fontWeight: '700',
      },
      '& .MuiTab-textColorPrimary': {
        color: '#707889', //commonization at src/view/constant/color.ts
        fontWeight: '700',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#4C566C',
        height: '3px',
      },
    },
  },
})(Tabs);

const Title = styled(Typography)(`
  font-weight: 700;
  font-size: 24px;
  color: ${COLOR_TEXT_MAIN};
`);

// const PrimaryButton = styled(LoadingButton)(`
//   color: #FFFFFF;
//   height: 40px;
//   font-size: 14px;
//   background: ${COLOR_TEXT_MAIN};
//   font-weight: 700;
//   border-color: ${COLOR_TEXT_MAIN};
//   border-radius: 4px;
//   padding: 12px 24px;
//   text-transform: none;
//   :hover {
//     background: #707889;
//     border-color: #707889;
//   }
//   :disabled {
//     background: #E6E7E8;
//     color: rgba(75, 85, 106, 0.24);
//     border: rgba(75, 85, 106, 0.24);
//   }
// `);

export default ExperimentDetailsPage;
